import { Ability } from '@casl/ability';
import { initialAbility } from './config';

//  Read ability from localStorage
const userData = JSON.parse(localStorage.getItem('userData'));
const existingAbility = userData ? userData.ability : null;

export default new Ability(existingAbility || initialAbility);
